//分组数据
const state = () => ({
  roleProfile: null,	//分组模式的权限信息
  groupDevices: null,  //原始分组数据
  groupErrorDesc: null,//错误描述


})

const mutations = {
  // 设置分组错误描述
  SET_GROUPERRORDESC: (state, groupErrorDesc) => {
    state.groupErrorDesc = groupErrorDesc
  },
  // 设置分组权限信息
  SET_ROLEPROFILE: (state, roleProfile) => {
    state.roleProfile = roleProfile
  },
  //设置原始分组数据
  SET_GROUPDEVICES: (state, groupDevices) => {
    state.groupDevices = groupDevices
  },
}
const actions = {

}
const getters = {
  getGroupDevices(state) {
    return state.groupDevices
  },
  getGroupErrorDesc(state) {
    return state.groupErrorDesc
  },
  getRoleProfile(state) {
    return state.roleProfile
  },
  // checkGroupErrorDesc(state) { 
  //   if (state == undefined || state == "") {
  //     return "未知错误"
  //   }
  //   const groupErrorDesc = this.groupErrorDesc
  //   return groupErrorDesc.hasOwnProperty(state) ? groupErrorDesc[state] : '未知错误'
  // },
}

export default {
  namespaced: true, //这个可以让在组件中直接通过mapState引用子仓库
  state,
  getters,
  actions,
  mutations
};